import React, { useEffect, useRef, useState } from 'react';
import RestAPIService from '../../../../Utility/Services/RestAPIService';
import { Serviceurls } from '../../../../Utility/API/Serviceurls';
import ToastMsg from '../../../../Components/ToastMsg/ToastMsg';
import Loader from '../../../../Components/Loader';
import { CommonPatientDetails } from '../../../../Components/Common Components/CommonComponents';
import { getCachevalue, localGetItem } from '../../../../Utility/Services/CacheProviderService';
import { Box, Button, Typography, CircularProgress, Grid, Chip, TextField } from '@mui/material';
import { Colors } from '../../../../Styles/Colors';
import { ImagePaths } from '../../../../Utility/ImagePaths';
import { Yes_Or_No } from '../../../../Utility/Constants';

const DocFootExamination = () => {
    const observerRef = useRef(null);
    const childComponentIds = ['footClinic', 'gait', 'deformities', 'addDeformities']

    const [formState, setFormState] = useState({
        clinicId: null,
        appointmentId: null,
        patientId: null,
        patientDetails: {},

        // Foot Clinic states
        footClinicData: [],
        footclinicEdit: false,
        skinTexture: {},
        skinColor: {},
        lossSweating: {},
        lyingSymmetrical: {},
        edema: {},
        cornCallus: {},
        cracksFissures: {},
        scratchMarks: {},
        infection: {},
        varicoseVeins: {},
        warmth: {},
        Cold: {},
        tenderness: {},
        hypopigmentedspot: {},
        hypopigmentedpatches: {},
        hyperpigmentedspot: {},
        hyperpigmentedpatches: {},

        // Gait states
        gaitData: [],
        gaitDataEdit: false,
        limping: {},
        waddling: {},
        highstepping: {},

        // Deformities states
        deformitiesData: [],
        deformitiesEdit: false,
        clawedtoes: {},
        hammertoes: {},
        pescavus: {},
        bunion: {},
        halluxrigidus: {},
        halluxflexus: {},
        crowdingoftoes: {},
        overridingoftoes: {},
        arches: {},
        flatfoot: {},
        dislocation: {},
        nails: {},
        fungalInfection: {},
        others: {},

        // Additional Deformities states
        addDeformitiesData: [],
        addDeformitiesEdit: false,
        dorsalisPedisArtery: {},
        posteriorTibialArtery: {},
        vibrationSensation: {},
        temperatureSensation: {},
        monofilament: {},
        kneeReflex: {},
        ankleReflex: {},
        addtionalOthers: {}

    });
    const [isLoader, setIsLoader] = useState(false);
    const [footClinicLoad, setFootClinicLoad] = useState(false);
    const [gaitLoad, setGaitLoad] = useState(false);
    const [deformitiesLoad, setDeformitiesLoad] = useState(false);
    const [addDeformLoad, setAddDeformLoad] = useState(false);
    const [errorMsg, seterrorMsg] = useState(false);
    const [errorMsgText, seterrorMsgText] = useState('');
    const [successMsg, setsuccessMsg] = useState(false);
    const [successMsgText, setsuccessMsgText] = useState('');

    useEffect(() => {
        var myUser = JSON.parse(localGetItem("loggedInUserInfo"))
        let clinicId = myUser?.clinic_id ? myUser?.clinic_id : getCachevalue('SelectedDoctorClinic')
        let appointmentId = JSON.parse(getCachevalue('DoctorPatientData'))
        setFormState((prevState) => ({
            ...prevState,
            clinicId: clinicId,
            appointmentId: appointmentId?.appointment_id,
            patientId: appointmentId?.patient_id
        }));
    }, [])

    useEffect(() => {
        if (formState?.patientId) {
            getPatientDetails()
        }
    }, [formState?.patientId])

    useEffect(() => {
        if (formState.appointmentId && formState.clinicId && formState.patientId) {
            setupIntersectionObserver()
        }
    }, [formState.appointmentId, formState.clinicId, formState.patientId])

    const getPatientDetails = () => {
        try {
            setIsLoader(true)
            RestAPIService.getAll(Serviceurls.DOC_PATIENT_DETAIL_GET + `?patient_id=${formState?.patientId}`)
                .then((response) => {
                    if (response.data.status === 'success') {
                        setFormState((prevState) => ({ ...prevState, patientDetails: response.data.data || [] }));
                        setIsLoader(false)
                    }
                }).catch(e => {
                    setIsLoader(false)
                    if (e?.response?.data?.status === 'fail') {
                        errorMessage(e.response.data.message)
                    } else {
                        errorMessage(e.message)
                    }
                })
        } catch (e) {
            setIsLoader(false)
            errorMessage(e.message)
        }
    }

    const getFootClinicData = () => {
        try {
            setFootClinicLoad(true)
            RestAPIService.getAll(Serviceurls.DOC_FOOT_EXAMINATION_GET + `?appointment_id=${formState?.appointmentId}&clinic_id=${formState?.clinicId}&patient_id=${formState?.patientId}`)
                .then((response) => {
                    if (response.data.status === 'Success') {
                        let data = response?.data?.data
                        if (Object.keys(data)?.length > 0) {
                            setFormState((prevState) => ({
                                ...prevState, footClinicData: data || [],
                                skinTexture: {
                                    choice: data[0]?.skin_texture ? 'Yes' : data[0]?.skin_texture === false ? 'No' : null,
                                    comment: data[0]?.skin_texture_comment || ''
                                },
                                skinColor: {
                                    choice: data[0]?.skin_colour ? 'Yes' : data[0]?.skin_colour === false ? 'No' : null,
                                    comment: data[0]?.skin_colour_comment || ''
                                },
                                lossSweating: {
                                    choice: data[0]?.loss_of_sweating ? 'Yes' : data[0]?.loss_of_sweating === false ? 'No' : null,
                                    comment: data[0]?.loss_of_sweating_comment || ''
                                },
                                lyingSymmetrical: {
                                    choice: data[0]?.lying_symmetrical ? 'Yes' : data[0]?.lying_symmetrical === false ? 'No' : null,
                                    comment: data[0]?.lying_symmetrical_comment || ''
                                },
                                edema: {
                                    choice: data[0]?.edema ? 'Yes' : data[0]?.edema === false ? 'No' : null,
                                    comment: data[0]?.edema_comment || ''
                                },
                                cornCallus: {
                                    choice: data[0]?.corn_callus ? 'Yes' : data[0]?.corn_callus === false ? 'No' : null,
                                    comment: data[0]?.corn_callus_comment || ''
                                },
                                cracksFissures: {
                                    choice: data[0]?.cracks_fissures ? 'Yes' : data[0]?.cracks_fissures === false ? 'No' : null,
                                    comment: data[0]?.cracks_fissures_comment || ''
                                },
                                scratchMarks: {
                                    choice: data[0]?.scratch_marks ? 'Yes' : data[0]?.scratch_marks === false ? 'No' : null,
                                    comment: data[0]?.scratch_marks_comment || ''
                                },
                                infection: {
                                    choice: data[0]?.infection ? 'Yes' : data[0]?.infection === false ? 'No' : null,
                                    comment: data[0]?.infection_comment || ''
                                },
                                varicoseVeins: {
                                    choice: data[0]?.varicose_veins ? 'Yes' : data[0]?.varicose_veins === false ? 'No' : null,
                                    comment: data[0]?.varicose_veins_comment || ''
                                },
                                warmth: {
                                    choice: data[0]?.wormth_cold ? 'Yes' : data[0]?.wormth_cold === false ? 'No' : null,
                                    comment: data[0]?.wormth_cold_comment || ''
                                },
                                Cold: {
                                    choice: data[0]?.cold ? 'Yes' : data[0]?.cold === false ? 'No' : null,
                                    comment: data[0]?.cold_comment || ''
                                },
                                tenderness: {
                                    choice: data[0]?.tenderness ? 'Yes' : data[0]?.tenderness === false ? 'No' : null,
                                    comment: data[0]?.tenderness_comment || ''
                                },
                                hypopigmentedspot: {
                                    choice: data[0]?.hypopigmented_spot ? 'Yes' : data[0]?.hypopigmented_spot === false ? 'No' : null,
                                    comment: data[0]?.hypopigmented_spot_comment || ''
                                },
                                hypopigmentedpatches: {
                                    choice: data[0]?.hypopigmented_patches ? 'Yes' : data[0]?.hypopigmented_patches === false ? 'No' : null,
                                    comment: data[0]?.hypopigmented_patches_comment || ''
                                },
                                hyperpigmentedspot: {
                                    choice: data[0]?.hyperpigmented_spot ? 'Yes' : data[0]?.hyperpigmented_spot === false ? 'No' : null,
                                    comment: data[0]?.hyperpigmented_spot_comment || ''
                                },
                                hyperpigmentedpatches: {
                                    choice: data[0]?.hyperpigmented_patches ? 'Yes' : data[0]?.hyperpigmented_patches === false ? 'No' : null,
                                    comment: data[0]?.hyperpigmented_patches_comment || ''
                                },
                                footclinicEdit: data[0]?.id ? true : false,
                            }));
                        }
                        setFootClinicLoad(false)
                    }
                }).catch(e => {
                    setFootClinicLoad(false)
                    if (e?.response?.data?.status === 'fail') {
                        errorMessage(e.response.data.message)
                    } else {
                        errorMessage(e.message)
                    }
                })
        } catch (e) {
            setFootClinicLoad(false)
            errorMessage(e.message)
        }
    }

    const getGaitData = () => {
        try {
            setGaitLoad(true)
            RestAPIService.getAll(Serviceurls.DOC_GAIT_GET + `?appointment_id=${formState?.appointmentId}&clinic_id=${formState?.clinicId}&patient_id=${formState?.patientId}`)
                .then((response) => {
                    if (response.data.status === 'Success') {
                        let data = response?.data?.data
                        if (Object.keys(data)?.length > 0) {
                            setFormState((prevState) => ({
                                ...prevState, gaitData: data || [],
                                limping: {
                                    choice: data[0]?.limping ? 'Yes' : data[0]?.limping === false ? 'No' : null,
                                    comment: data[0]?.limping_comment || ''
                                },
                                waddling: {
                                    choice: data[0]?.wadding ? 'Yes' : data[0]?.wadding === false ? 'No' : null,
                                    comment: data[0]?.wadding_comment || ''
                                },
                                highstepping: {
                                    choice: data[0]?.high_stepping ? 'Yes' : data[0]?.high_stepping === false ? 'No' : null,
                                    comment: data[0]?.high_stepping_comment || ''
                                },
                                gaitDataEdit: data[0]?.id ? true : false,
                            }));
                        }
                        setGaitLoad(false)
                    }
                }).catch(e => {
                    setGaitLoad(false)
                    if (e?.response?.data?.status === 'fail') {
                        errorMessage(e.response.data.message)
                    } else {
                        errorMessage(e.message)
                    }
                })
        } catch (e) {
            setGaitLoad(false)
            errorMessage(e.message)
        }
    }

    const getDeformities = () => {
        try {
            setDeformitiesLoad(true)
            RestAPIService.getAll(Serviceurls.DOC_DEFORMITIES_GET + `?appointment_id=${formState?.appointmentId}&clinic_id=${formState?.clinicId}&patient_id=${formState?.patientId}`)
                .then((response) => {
                    if (response.data.status === 'Success') {
                        let data = response?.data?.data
                        if (Object.keys(data)?.length > 0) {
                            setFormState((prevState) => ({
                                ...prevState,
                                deformitiesData: response.data.data || [],
                                clawedtoes: {
                                    choice: data[0]?.clawed_toes ? 'Yes' : data[0]?.clawed_toes === false ? 'No' : null,
                                    comment: data[0]?.clawed_toes_comment || ''
                                },
                                hammertoes: {
                                    choice: data[0]?.hammer_toes ? 'Yes' : data[0]?.hammer_toes === false ? 'No' : null,
                                    comment: data[0]?.hammer_toes_comment || ''
                                },
                                pescavus: {
                                    choice: data[0]?.pes_cavus ? 'Yes' : data[0]?.pes_cavus === false ? 'No' : null,
                                    comment: data[0]?.pes_cavus_comment || ''
                                },
                                bunion: {
                                    choice: data[0]?.bunion ? 'Yes' : data[0]?.bunion === false ? 'No' : null,
                                    comment: data[0]?.bunion_comment || ''
                                },
                                halluxrigidus: {
                                    choice: data[0]?.hallux_rigidus ? 'Yes' : data[0]?.hallux_rigidus === false ? 'No' : null,
                                    comment: data[0]?.hallux_rigidus_comment || ''
                                },
                                halluxflexus: {
                                    choice: data[0]?.hallux_flexus ? 'Yes' : data[0]?.hallux_flexus === false ? 'No' : null,
                                    comment: data[0]?.hallux_flexus_comment || ''
                                },
                                crowdingoftoes: {
                                    choice: data[0]?.crowding_of_toes ? 'Yes' : data[0]?.crowding_of_toes === false ? 'No' : null,
                                    comment: data[0]?.crowding_of_toes_comment || ''
                                },
                                overridingoftoes: {
                                    choice: data[0]?.overriding_of_toes ? 'Yes' : data[0]?.overriding_of_toes === false ? 'No' : null,
                                    comment: data[0]?.overriding_of_toes_comment || ''
                                },
                                arches: {
                                    choice: data[0]?.arches ? 'Yes' : data[0]?.arches === false ? 'No' : null,
                                    comment: data[0]?.arches_comment || ''
                                },
                                flatfoot: {
                                    choice: data[0]?.flat_foot ? 'Yes' : data[0]?.flat_foot === false ? 'No' : null,
                                    comment: data[0]?.flat_foot_comment || ''
                                },
                                dislocation: {
                                    choice: data[0]?.dislocation ? 'Yes' : data[0]?.dislocation === false ? 'No' : null,
                                    comment: data[0]?.dislocation_comment || ''
                                },
                                nails: {
                                    choice: data[0]?.nails ? 'Yes' : data[0]?.nails === false ? 'No' : null,
                                    comment: data[0]?.nails_comment || ''
                                },
                                fungalInfection: {
                                    choice: data[0]?.maceration_fungal ? 'Yes' : data[0]?.maceration_fungal === false ? 'No' : null,
                                    comment: data[0]?.maceration_fungal_comment || ''
                                },
                                others: {
                                    choice: data[0]?.others ? 'Yes' : data[0]?.others === false ? 'No' : null,
                                    comment: data[0]?.others_comment || ''
                                },
                                deformitiesEdit: data[0]?.id ? true : false,
                            }));
                        }
                        setDeformitiesLoad(false)
                    }
                }).catch(e => {
                    setDeformitiesLoad(false)
                    if (e?.response?.data?.status === 'fail') {
                        errorMessage(e.response.data.message)
                    } else {
                        errorMessage(e.message)
                    }
                })
        } catch (e) {
            setDeformitiesLoad(false)
            errorMessage(e.message)
        }
    }

    const getAddDeformities = () => {
        try {
            setAddDeformLoad(true)
            RestAPIService.getAll(Serviceurls.DOC_DEFORMITIES_ADDITIONAL_GET + `?appointment_id=${formState?.appointmentId}&clinic_id=${formState?.clinicId}&patient_id=${formState?.patientId}`)
                .then((response) => {
                    if (response.data.status === 'Success') {
                        let data = response?.data?.data
                        if (Object.keys(data)?.length > 0) {
                            setFormState((prevState) => ({
                                ...prevState, addDeformitiesData: data || [],
                                dorsalisPedisArtery: {
                                    right: data[0]?.dorsalis_pedis_right || null,
                                    left: data[0]?.dorsalis_pedis_left || null,
                                },
                                posteriorTibialArtery: {
                                    right: data[0]?.posterior_tibial_right || null,
                                    left: data[0]?.posterior_tibial_left || null,
                                },
                                vibrationSensation: {
                                    right: data[0]?.vibration_right || null,
                                    left: data[0]?.vibration_left || null,
                                },
                                temperatureSensation: {
                                    right: data[0]?.temperature_right || null,
                                    left: data[0]?.temperature_left || null,
                                },
                                monofilament: {
                                    right: data[0]?.monofilament_right || null,
                                    left: data[0]?.monofilament_left || null,
                                },
                                kneeReflex: {
                                    right: data[0]?.knee_reflex_right || null,
                                    left: data[0]?.knee_reflex_left || null,
                                },
                                ankleReflex: {
                                    right: data[0]?.ankle_reflex_right || null,
                                    left: data[0]?.ankle_reflex_left || null,
                                },
                                addtionalOthers: {
                                    right: data[0]?.others_right || null,
                                    left: data[0]?.others_left || null,
                                },
                                addDeformitiesEdit: data[0]?.id ? true : false,
                            }));
                        }
                        setAddDeformLoad(false)
                    }
                }).catch(e => {
                    setAddDeformLoad(false)
                    if (e?.response?.data?.status === 'fail') {
                        errorMessage(e.response.data.message)
                    } else {
                        errorMessage(e.message)
                    }
                })
        } catch (e) {
            setAddDeformLoad(false)
            errorMessage(e.message)
        }
    }

    const setupIntersectionObserver = () => {
        try {
            const options = { threshold: 0.25 }
            observerRef.current = new IntersectionObserver(interSectionHandler, options)
            childComponentIds.forEach(id => {
                const element = document.getElementById(id)
                if (element) {
                    observerRef.current.observe(element)
                }
            })
        } catch (error) {
            errorMessage(error.message)
        }
    }

    const interSectionHandler = (entries) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                const childId = entry.target.id
                diagnosisHistoryAPICall(childId)
                observerRef.current?.unobserve(entry.target)
            }
        })
    }

    const diagnosisHistoryAPICall = (item) => {
        try {
            switch (item) {
                case 'footClinic':
                    getFootClinicData()
                    break;
                case 'gait':
                    getGaitData()
                    break;
                case 'deformities':
                    getDeformities()
                    break;
                case 'addDeformities':
                    getAddDeformities()
                    break;
                default: break;
            }
        } catch (error) {
            errorMessage(error.message)
        }
    }

    const PostFootClinicData = () => {
        try {
            let data = {
                appointment_id: formState.appointmentId,
                clinic_id: parseInt(formState.clinicId),
                patient_id: formState.patientId,
                skin_texture: formState.skinTexture?.choice === 'Yes' ? true : formState.skinTexture?.choice === 'No' ? false : null,
                skin_texture_comment: formState.skinTexture.comment || null,
                skin_colour: formState.skinColor?.choice === 'Yes' ? true : formState.skinColor?.choice === 'No' ? false : null,
                skin_colour_comment: formState.skinColor.comment || null,
                loss_of_sweating: formState.lossSweating?.choice === 'Yes' ? true : formState.lossSweating?.choice === 'No' ? false : null,
                loss_of_sweating_comment: formState.lossSweating.comment || null,
                lying_symmetrical: formState.lyingSymmetrical?.choice === 'Yes' ? true : formState.lyingSymmetrical?.choice === 'No' ? false : null,
                lying_symmetrical_comment: formState.lyingSymmetrical?.comment || null,
                edema: formState.edema?.choice === 'Yes' ? true : formState.edema?.choice === 'No' ? false : null,
                edema_comment: formState.edema?.comment || null,
                corn_callus: formState.cornCallus?.choice === 'Yes' ? true : formState.cornCallus?.choice === 'No' ? false : null,
                corn_callus_comment: formState.cornCallus?.comment || null,
                cracks_fissures: formState.cracksFissures?.choice === 'Yes' ? true : formState.cracksFissures?.choice === 'No' ? false : null,
                cracks_fissures_comment: formState.cracksFissures?.comment || null,
                scratch_marks: formState.scratchMarks?.choice === 'Yes' ? true : formState.scratchMarks?.choice === 'No' ? false : null,
                scratch_marks_comment: formState.scratchMarks?.comment || null,
                infection: formState.infection?.choice === 'Yes' ? true : formState.infection?.choice === 'No' ? false : null,
                infection_comment: formState.infection?.comment || null,
                varicose_veins: formState.varicoseVeins?.choice === 'Yes' ? true : formState.varicoseVeins?.choice === 'No' ? false : null,
                varicose_veins_comment: formState.varicoseVeins?.comment || null,
                wormth_cold: formState.warmth?.choice === 'Yes' ? true : formState.warmth?.choice === 'No' ? false : null,
                wormth_cold_comment: formState.warmth?.comment || null,
                cold: formState.Cold?.choice === 'Yes' ? true : formState.Cold?.choice === 'No' ? false : null,
                cold_comment: formState.Cold?.comment || null,
                tenderness: formState.tenderness?.choice === 'Yes' ? true : formState.tenderness?.choice === 'No' ? false : null,
                tenderness_comment: formState.tenderness?.comment || null,
                hypopigmented_spot: formState.hypopigmentedspot?.choice === 'Yes' ? true : formState.hypopigmentedspot?.choice === 'No' ? false : null,
                hypopigmented_spot_comment: formState.hypopigmentedspot?.comment || null,
                hypopigmented_patches: formState.hypopigmentedpatches?.choice === 'Yes' ? true : formState.hypopigmentedpatches?.choice === 'No' ? false : null,
                hypopigmented_patches_comment: formState.hypopigmentedpatches?.comment || null,
                hyperpigmented_spot: formState.hyperpigmentedspot?.choice === 'Yes' ? true : formState.hyperpigmentedspot?.choice === 'No' ? false : null,
                hyperpigmented_spot_comment: formState.hyperpigmentedspot?.comment || null,
                hyperpigmented_patches: formState.hyperpigmentedpatches?.choice === 'Yes' ? true : formState.hyperpigmentedpatches?.choice === 'No' ? false : null,
                hyperpigmented_patches_comment: formState.hyperpigmentedpatches?.comment || null,
                id: formState?.footClinicData[0]?.id ? formState?.footClinicData[0]?.id : null,
            };
            setFootClinicLoad(true)
            RestAPIService.create(data, Serviceurls.DOC_FOOT_EXAMINATION_GET)
                .then((response) => {
                    if (response.data.status === 'success') {
                        setFootClinicLoad(false)
                        successMessage(response.data.message)
                        ClearFootClinicData()
                        getFootClinicData()
                    }
                }).catch(e => {
                    setFootClinicLoad(false)
                    if (e?.response?.data?.status === 'fail') {
                        errorMessage(e.response.data.message)
                    } else {
                        errorMessage(e.message)
                    }
                })
        } catch (e) {
            setFootClinicLoad(false)
            errorMessage(e.message)
        }
    }

    const PostGaitData = () => {
        try {
            let data = {
                appointment_id: formState.appointmentId,
                clinic_id: parseInt(formState.clinicId),
                patient_id: formState.patientId,
                limping: formState.limping?.choice === 'Yes' ? true : formState.limping?.choice === 'No' ? false : null,
                limping_comment: formState.limping?.comment || null,
                wadding: formState.waddling?.choice === 'Yes' ? true : formState.waddling?.choice === 'No' ? false : null,
                wadding_comment: formState.waddling?.comment || null,
                high_stepping: formState.highstepping?.choice === 'Yes' ? true : formState.highstepping?.choice === 'No' ? false : null,
                high_stepping_comment: formState.highstepping?.comment || null,
                id: formState?.gaitData[0]?.id ? formState?.gaitData[0]?.id : null,
            };
            setFootClinicLoad(true)
            RestAPIService.create(data, Serviceurls.DOC_GAIT_GET)
                .then((response) => {
                    if (response.data.status === 'success') {
                        setFootClinicLoad(false)
                        successMessage(response.data.message)
                        ClearGaitData()
                        getGaitData()
                    }
                }).catch(e => {
                    setFootClinicLoad(false)
                    if (e?.response?.data?.status === 'fail') {
                        errorMessage(e.response.data.message)
                    } else {
                        errorMessage(e.message)
                    }
                })
        } catch (e) {
            setFootClinicLoad(false)
            errorMessage(e.message)
        }
    }

    const PostDeformitiesData = () => {
        try {
            let data = {
                appointment_id: formState.appointmentId,
                clinic_id: parseInt(formState.clinicId),
                patient_id: formState.patientId,
                clawed_toes: formState.clawedtoes?.choice === 'Yes' ? true : formState.clawedtoes?.choice === 'No' ? false : null,
                clawed_toes_comment: formState.clawedtoes?.comment || null,
                hammer_toes: formState.hammertoes?.choice === 'Yes' ? true : formState.hammertoes?.choice === 'No' ? false : null,
                hammer_toes_comment: formState.hammertoes?.comment || null,
                pes_cavus: formState.pescavus?.choice === 'Yes' ? true : formState.pescavus?.choice === 'No' ? false : null,
                pes_cavus_comment: formState.pescavus?.comment || null,
                bunion: formState.bunion?.choice === 'Yes' ? true : formState.bunion?.choice === 'No' ? false : null,
                bunion_comment: formState.bunion?.comment || null,
                hallux_rigidus: formState.halluxrigidus?.choice === 'Yes' ? true : formState.halluxrigidus?.choice === 'No' ? false : null,
                hallux_rigidus_comment: formState.halluxrigidus?.comment || null,
                hallux_flexus: formState.halluxflexus?.choice === 'Yes' ? true : formState.halluxflexus?.choice === 'No' ? false : null,
                hallux_flexus_comment: formState.halluxflexus?.comment || null,
                crowding_of_toes: formState.crowdingoftoes?.choice === 'Yes' ? true : formState.crowdingoftoes?.choice === 'No' ? false : null,
                crowding_of_toes_comment: formState.crowdingoftoes?.comment || null,
                overriding_of_toes: formState.overridingoftoes?.choice === 'Yes' ? true : formState.overridingoftoes?.choice === 'No' ? false : null,
                overriding_of_toes_comment: formState.overridingoftoes?.comment || null,
                arches: formState.arches?.choice === 'Yes' ? true : formState.arches?.choice === 'No' ? false : null,
                arches_comment: formState.arches?.comment || null,
                flat_foot: formState.flatfoot?.choice === 'Yes' ? true : formState.flatfoot?.choice === 'No' ? false : null,
                flat_foot_comment: formState.flatfoot?.comment || null,
                dislocation: formState.dislocation?.choice === 'Yes' ? true : formState.dislocation?.choice === 'No' ? false : null,
                dislocation_comment: formState.dislocation?.comment || null,
                nails: formState.nails?.choice === 'Yes' ? true : formState.nails?.choice === 'No' ? false : null,
                nails_comment: formState.nails?.comment || null,
                maceration_fungal: formState.fungalInfection?.choice === 'Yes' ? true : formState.fungalInfection?.choice === 'No' ? false : null,
                maceration_fungal_comment: formState.fungalInfection?.comment || null,
                others: formState.others?.choice === 'Yes' ? true : formState.others?.choice === 'No' ? false : null,
                others_comment: formState.others?.comment || null,
                id: formState?.deformitiesData[0]?.id ? formState?.deformitiesData[0]?.id : null,
            };
            setFootClinicLoad(true)
            RestAPIService.create(data, Serviceurls.DOC_DEFORMITIES_GET)
                .then((response) => {
                    if (response.data.status === 'success') {
                        setFootClinicLoad(false)
                        successMessage(response.data.message)
                        ClearDeformitiesData()
                        getDeformities()
                    }
                }).catch(e => {
                    setFootClinicLoad(false)
                    if (e?.response?.data?.status === 'fail') {
                        errorMessage(e.response.data.message)
                    } else {
                        errorMessage(e.message)
                    }
                })
        } catch (e) {
            setFootClinicLoad(false)
            errorMessage(e.message)
        }
    }

    const PostAddDeformitiesData = () => {
        try {
            let data = {
                appointment_id: formState.appointmentId,
                clinic_id: parseInt(formState.clinicId),
                patient_id: formState.patientId,
                dorsalis_pedis_right: formState.dorsalisPedisArtery?.right || null,
                dorsalis_pedis_left: formState.dorsalisPedisArtery?.left || null,
                posterior_tibial_right: formState.posteriorTibialArtery?.right || null,
                posterior_tibial_left: formState.posteriorTibialArtery?.left || null,
                vibration_right: formState.vibrationSensation?.right || null,
                vibration_left: formState.vibrationSensation?.left || null,
                temperature_right: formState.temperatureSensation?.right || null,
                temperature_left: formState.temperatureSensation?.left || null,
                monofilament_right: formState.monofilament?.right || null,
                monofilament_left: formState.monofilament?.left || null,
                knee_reflex_right: formState.kneeReflex?.right || null,
                knee_reflex_left: formState.kneeReflex?.left || null,
                ankle_reflex_right: formState.ankleReflex?.right || null,
                ankle_reflex_left: formState.ankleReflex?.left || null,
                others_right: formState.addtionalOthers?.right || null,
                others_left: formState.addtionalOthers?.left || null,
                id: formState?.addDeformitiesData[0]?.id ? formState?.addDeformitiesData[0]?.id : null,
            };
            setFootClinicLoad(true)
            RestAPIService.create(data, Serviceurls.DOC_DEFORMITIES_ADDITIONAL_GET)
                .then((response) => {
                    if (response.data.status === 'success') {
                        setFootClinicLoad(false)
                        successMessage(response.data.message)
                        ClearAddDeformitiesData()
                        getAddDeformities()
                    }
                }).catch(e => {
                    setFootClinicLoad(false)
                    if (e?.response?.data?.status === 'fail') {
                        errorMessage(e.response.data.message)
                    } else {
                        errorMessage(e.message)
                    }
                })
        } catch (e) {
            setFootClinicLoad(false)
            errorMessage(e.message)
        }
    }

    const printFootExaminationData = () => {
        try {
            RestAPIService.getAllPrint(Serviceurls.DOC_FOOT_EXAMINATION_PRINT + `?appointment_id=${formState?.appointmentId}&export=pdf`)
                .then((response) => {
                    const file = new Blob(
                        [response.data],
                        { type: 'application/pdf' });
                    const fileURL = URL.createObjectURL(file);
                    window.open(fileURL);
                }).catch((error) => {
                    if (error?.response?.data?.message) {
                        errorMessage(error.response.data.message)
                    } else {
                        errorMessage(error.message)
                    }
                })
        } catch (error) {
            errorMessage(error.message)
        }
    }

    const ClearFootClinicData = () => {
        try {
            setFormState((prevState) => ({
                ...prevState,
                skinTexture: {},
                skinColor: {},
                lossSweating: {},
                lyingSymmetrical: {},
                edema: {},
                cornCallus: {},
                cracksFissures: {},
                scratchMarks: {},
                infection: {},
                varicoseVeins: {},
                warmth: {},
                Cold: {},
                tenderness: {},
                hypopigmentedspot: {},
                hypopigmentedpatches: {},
                hyperpigmentedspot: {},
                hyperpigmentedpatches: {},
            }));
        } catch (error) {
            errorMessage(error.message);
        }
    }

    const ClearGaitData = () => {
        try {
            setFormState((prevState) => ({
                ...prevState,
                limping: {},
                waddling: {},
                highstepping: {},
            }));
        } catch (error) {
            errorMessage(error.message);
        }
    }

    const ClearDeformitiesData = () => {
        try {
            setFormState((prevState) => ({
                ...prevState,
                clawedtoes: {},
                hammertoes: {},
                pescavus: {},
                bunion: {},
                halluxrigidus: {},
                halluxflexus: {},
                crowdingoftoes: {},
                overridingoftoes: {},
                arches: {},
                flatfoot: {},
                dislocation: {},
                nails: {},
                fungalInfection: {},
                others: {},
            }));
        } catch (error) {
            errorMessage(error.message);
        }
    }

    const ClearAddDeformitiesData = () => {
        try {
            setFormState((prevState) => ({
                ...prevState,
                dorsalisPedisArtery: {},
                posteriorTibialArtery: {},
                vibrationSensation: {},
                temperatureSensation: {},
                monofilament: {},
                kneeReflex: {},
                ankleReflex: {},
                addtionalOthers: {},
            }));
        } catch (error) {
            errorMessage(error.message);
        }
    }

    const msgClose = () => {
        seterrorMsg(false);
        seterrorMsgText('');
        setsuccessMsg(false);
        setsuccessMsgText('');
    };

    const errorMessage = (msg) => {
        seterrorMsgText(msg);
        seterrorMsg(true);
    };

    const successMessage = (msg) => {
        setsuccessMsgText(msg);
        setsuccessMsg(true);
    };

    const handleCommentChange = (key, comment) => {
        setFormState((prev) => ({
            ...prev,
            [key]: {
                ...prev[key],
                comment,
            },
        }));
    };

    const handleChipClick = (label, key) => {
        if (label === formState[key]?.choice) {
            setFormState((prev) => ({
                ...prev,
                [key]: {
                    ...prev[key],
                    choice: null,
                },
            }));
        } else {
            setFormState((prev) => ({
                ...prev,
                [key]: {
                    ...prev[key],
                    choice: label,
                },
            }));
        }
    };

    const renderFieldRow = (key, label, isDisable = false) => {
        const fieldData = formState[key] || {};
        return (
            <Box key={key} sx={{ mb: '1vw', width: "100%", display: "flex", gap:"0.6dvw", alignItems: "center" }}>
                <Box sx={{ width: '10dvw' }}>{label}</Box>
                <Box component={'div'} style={{ display: 'flex', flexDirection: 'row' }}>
                    {Yes_Or_No?.map((item, index) => (
                        <Chip
                            className={`eMed_chip ${item.label === fieldData.choice ? 'eMed_Chip_OnClick' : 'eMed_Chip_Border'}`}
                            label={item.label}
                            size='small'
                            disabled = {isDisable}
                            variant={item.label === fieldData.choice ? 'contained' : 'outlined'}
                            key={index}
                            onClick={() => handleChipClick(item.label, key)}
                            clickable
                        />
                    ))}
                </Box>
                    <TextField
                        size="small"
                        fullWidth
                        sx={{width: "26.85dvw"}}
                        inputProps={{ maxLength: 100 }}
                        disabled = {isDisable}
                        rows = {2}
                        multiline
                        value={fieldData.comment || ''}
                        onChange={(e) => handleCommentChange(key, e.target.value)}
                    />
            </Box>
        );
    };

    const renderTextFieldRow = (label, fieldKey, showHeader = false, isDisable = false) => {
        return (
            <Box display="flex" flexDirection="column" mb={1}>
                {showHeader && (
                    <Box display="flex" alignItems="center" mb={0.5}>
                        <Box width="25vw" />
                        <Box width="25vw" fontWeight="bold" fontSize="0.85vw" textAlign="center">RIGHT</Box>
                        <Box width="25vw" fontWeight="bold" fontSize="0.85vw" textAlign="center">LEFT</Box>
                    </Box>
                )}

                <Box display="flex" alignItems="center">
                    <Box width="25vw" pr={2}>
                        {label}
                    </Box>

                    <TextField
                        variant="outlined"
                        size="small"
                        inputProps={{ maxLength: 100 }}
                        disabled = {isDisable}
                        value={formState?.[fieldKey]?.right || ''}
                        onChange={(e) => handleDeformityChange(fieldKey, 'right', e.target.value)}
                        sx={{ width: '25vw', mr: '1vw' }}
                    />

                    <TextField
                        variant="outlined"
                        size="small"
                        inputProps={{ maxLength: 100 }}
                        disabled = {isDisable}
                        value={formState?.[fieldKey]?.left || ''}
                        onChange={(e) => handleDeformityChange(fieldKey, 'left', e.target.value)}
                        sx={{ width: '25vw' }}
                    />
                </Box>
            </Box>
        );
    };

    const handleDeformityChange = (key, side, value) => {
        setFormState(prev => ({
            ...prev,
            [key]: {
                ...prev[key],
                [side]: value
            }
        }));
    };


    const renderFootClinicBox = () => {
        try {
            return (
                <Box id='footClinic' component={'div'} border={'1px solid lightgray'} mt={'0.5vw'} sx={{ backgroundColor: Colors.white }}>
                    <Box component={'div'} sx={{ backgroundColor: Colors.Background }} height={'2.5vw'} display={'flex'} justifyContent={'space-between'} pl={'0.5vw'} alignItems={'center'}>
                        <Typography fontSize={'0.9vw'} fontWeight={600} color={Colors.SecondaryText}>{'Foot Clinic'}</Typography>
                        {formState?.footclinicEdit ?
                            <Box>
                                <Button className='Common_Btn_Min_Width' onClick={() => {
                                    setFormState((prevState) => ({
                                        ...prevState, footclinicEdit: false
                                    }))
                                }} emed_tid="doc_foot_exam_foot_clinic_edit_btn">
                                    <Box component={'img'} src={ImagePaths.UserEditOn.default} height={'1.5vw'} width={'1.5vw'} />
                                </Button>
                            </Box>
                            :
                            <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                                <Button variant='contained'
                                    disabled={footClinicLoad || getCachevalue('DoctorUserChanged') === 'true'}
                                    sx={{ textTransform: 'capitalize', height: '2vw', width: '5vw', mr: '1vw' }}
                                    onClick={() => PostFootClinicData()}
                                    emed_tid="doc_foot_exam_foot_clinic_add_btn"
                                >Add</Button>
                                <Button variant='outlined'
                                    sx={{ textTransform: 'capitalize', height: '2vw', width: '5vw', mr: '1vw' }}
                                    onClick={() => ClearFootClinicData()}
                                    emed_tid="doc_foot_exam_foot_clinic_clear_btn"
                                >Clear</Button>
                            </Box>
                        }
                    </Box>
                    {footClinicLoad ? <Box component={'div'} pl={'0.5vw'} pr={'0.5vw'} mb={'1vw'} height={'20vw'} display={'flex'} justifyContent={'center'} alignItems={'center'}><CircularProgress color='primary' /></Box> :
                        <Box component={'div'} pl={'0.5vw'} pr={'0.5vw'} mb={'1vw'}>
                            <Box component={'div'} width = "100%" display={'flex'} flexDirection={'row'} gap = {"0.625dvw"} mt={'0.75vw'}>
                                <Box width = {"50%"}>
                                    {renderFieldRow('skinTexture', 'Skin Texture', formState?.footclinicEdit)}
                                    {renderFieldRow('skinColor', 'Skin Colour', formState?.footclinicEdit)}
                                    {renderFieldRow('lossSweating', 'Loss of Sweating', formState?.footclinicEdit)}
                                    {renderFieldRow('lyingSymmetrical', 'Lying Symmetrical', formState?.footclinicEdit)}
                                    {renderFieldRow('edema', 'Edema', formState?.footclinicEdit)}
                                    {renderFieldRow('cornCallus', 'Corn/Callus', formState?.footclinicEdit)}
                                    {renderFieldRow('cracksFissures', 'Cracks/Fissures', formState?.footclinicEdit)}
                                    {renderFieldRow('hypopigmentedspot', 'Hypopigmented Spot', formState?.footclinicEdit)}
                                    {renderFieldRow('hypopigmentedpatches', 'Hypopigmented Patches', formState?.footclinicEdit)}
                                </Box>
                                <Box width = {"50%"}>
                                    {renderFieldRow('scratchMarks', 'Scratch Marks', formState?.footclinicEdit)}
                                    {renderFieldRow('infection', 'Infection', formState?.footclinicEdit)}
                                    {renderFieldRow('varicoseVeins', 'Varicose Veins', formState?.footclinicEdit)}
                                    {renderFieldRow('warmth', 'Warmth', formState?.footclinicEdit)}
                                    {renderFieldRow('Cold', 'Cold', formState?.footclinicEdit)}
                                    {renderFieldRow('tenderness', 'Tenderness', formState?.footclinicEdit)}
                                    {renderFieldRow('hyperpigmentedspot', 'Hyperpigmented Spot', formState?.footclinicEdit)}
                                    {renderFieldRow('hyperpigmentedpatches', 'Hyperpigmented Patches', formState?.footclinicEdit)}
                                </Box>
                            </Box>
                        </Box>
                    }
                </Box>
            );
        } catch (error) {
            errorMessage(error.message)
        }
    };

    const renderGaitBox = () => {
        try {
            return (
                <Box id='gait' component={'div'} border={'1px solid lightgray'} mt={'0.5vw'} sx={{ backgroundColor: Colors.white }}>
                    <Box component={'div'} sx={{ backgroundColor: Colors.Background }} height={'2.5vw'} display={'flex'} justifyContent={'space-between'} pl={'0.5vw'} alignItems={'center'}>
                        <Typography fontSize={'0.9vw'} fontWeight={600} color={Colors.SecondaryText}>{'Gait'}</Typography>
                        {formState?.gaitDataEdit ?
                            <Button className='Common_Btn_Min_Width' onClick={() => {
                                setFormState((prevState) => ({
                                    ...prevState, gaitDataEdit: false
                                }))
                            }} emed_tid="doc_foot_exam_gait_edit_btn">
                                <Box component={'img'} src={ImagePaths.UserEditOn.default} height={'1.5vw'} width={'1.5vw'} />
                            </Button>
                            :
                            <Box display={'flex'}>
                                <Button variant='contained'
                                    disabled={gaitLoad || getCachevalue('DoctorUserChanged') === 'true'}
                                    sx={{ textTransform: 'capitalize', height: '2vw', width: '5vw', mr: '1vw' }}
                                    onClick={() => PostGaitData()}
                                    emed_tid="doc_foot_exam_gait_add_btn"
                                >Add</Button>
                                <Button variant='outlined'
                                    sx={{ textTransform: 'capitalize', height: '2vw', width: '5vw', mr: '1vw' }}
                                    onClick={() => ClearGaitData()}
                                    emed_tid="doc_foot_exam_gait_clear_btn"
                                >Clear</Button>
                            </Box>
                        }
                    </Box>
                    {gaitLoad ? <Box component={'div'} pl={'0.5vw'} pr={'0.5vw'} mb={'1vw'} height={'20vw'} display={'flex'} justifyContent={'center'} alignItems={'center'}><CircularProgress color='primary' /></Box> :
                        <Box component={'div'} pl={'0.5vw'} pr={'0.5vw'} mb={'1vw'}>
                            <Box component={'div'} display={'flex'} flexDirection={'row'} gap = {"0.625dvw"} mt={'0.75vw'}>
                                <Box width={"50%"}>
                                    {renderFieldRow('limping', 'Limping', formState?.gaitDataEdit)}
                                    {renderFieldRow('waddling', 'Waddling', formState?.gaitDataEdit)}
                                    {renderFieldRow('highstepping', 'High Stepping', formState?.gaitDataEdit)}
                                </Box>
                            </Box>
                        </Box>
                    }
                </Box>
            );
        } catch (error) {
            errorMessage(error.message)
        }
    };

    const renderDeformitiesBox = () => {
        try {
            return (
                <Box id='deformities' component={'div'} border={'1px solid lightgray'} mt={'0.5vw'} sx={{ backgroundColor: Colors.white }}>
                    <Box component={'div'} sx={{ backgroundColor: Colors.Background }} height={'2.5vw'} display={'flex'} justifyContent={'space-between'} pl={'0.5vw'} alignItems={'center'}>
                        <Typography fontSize={'0.9vw'} fontWeight={600} color={Colors.SecondaryText}>{'Deformities'}</Typography>
                        {formState?.deformitiesEdit ?
                            <Button className='Common_Btn_Min_Width' onClick={() => {
                                setFormState((prevState) => ({
                                    ...prevState, deformitiesEdit: false
                                }))
                            }}>
                                <Box component={'img'} src={ImagePaths.UserEditOn.default} height={'1.5vw'} width={'1.5vw'} />
                            </Button>
                            :
                            <Box display={'flex'}>
                                <Button variant='contained'
                                    disabled={deformitiesLoad || getCachevalue('DoctorUserChanged') === 'true'}
                                    sx={{ textTransform: 'capitalize', height: '2vw', width: '5vw', mr: '1vw' }}
                                    onClick={() => PostDeformitiesData()}
                                >Add</Button>
                                <Button variant='outlined'
                                    sx={{ textTransform: 'capitalize', height: '2vw', width: '5vw', mr: '1vw' }}
                                    onClick={() => ClearDeformitiesData()}
                                >Clear</Button>
                            </Box>
                        }
                    </Box>
                    {deformitiesLoad ? <Box component={'div'} pl={'0.5vw'} pr={'0.5vw'} mb={'1vw'} height={'20vw'} display={'flex'} justifyContent={'center'} alignItems={'center'}><CircularProgress color='primary' /></Box> :
                        <Box component={'div'} pl={'0.5vw'} pr={'0.5vw'} mb={'1vw'}>
                            <Box component={'div'} display={'flex'} flexDirection={'row'} gap = {"0.625dvw"} mt={'0.75vw'}>
                                <Box width = "50%">
                                    {renderFieldRow('clawedtoes', 'Clawed Toes', formState?.deformitiesEdit)}
                                    {renderFieldRow('hammertoes', 'Hammer Toes', formState?.deformitiesEdit)}
                                    {renderFieldRow('pescavus', 'Pes Cavus', formState?.deformitiesEdit)}
                                    {renderFieldRow('bunion', 'Bunion', formState?.deformitiesEdit)}
                                    {renderFieldRow('halluxrigidus', 'Hallux Rigidus', formState?.deformitiesEdit)}
                                    {renderFieldRow('halluxflexus', 'Hallux Flexus ', formState?.deformitiesEdit)}
                                    {renderFieldRow('crowdingoftoes', 'Crowding of toes ', formState?.deformitiesEdit)}
                                </Box>
                                <Box width = "50%">
                                    {renderFieldRow('overridingoftoes', 'Overriding of toes', formState?.deformitiesEdit)}
                                    {renderFieldRow('arches', 'High Arches', formState?.deformitiesEdit)}
                                    {renderFieldRow('flatfoot', 'Flat Foot', formState?.deformitiesEdit)}
                                    {renderFieldRow('dislocation', 'Dislocation', formState?.deformitiesEdit)}
                                    {renderFieldRow('nails', 'Nails ', formState?.deformitiesEdit)}
                                    {renderFieldRow('fungalInfection', 'Web space maceration / Fungal Infection', formState?.deformitiesEdit)}
                                    {renderFieldRow('others', 'Others', formState?.deformitiesEdit)}
                                </Box>
                            </Box>
                        </Box>
                    }
                </Box>
            );
        } catch (error) {
            errorMessage(error.message)
        }
    };

    const renderAddDeformitiesBox = () => {
        try {
            return (
                <Box id='addDeformities' component={'div'} border={'1px solid lightgray'} mt={'0.5vw'} sx={{ backgroundColor: Colors.white }}>
                    <Box component={'div'} sx={{ backgroundColor: Colors.Background }} height={'2.5vw'} display={'flex'} justifyContent={'space-between'} pl={'0.5vw'} alignItems={'center'}>
                        <Typography fontSize={'0.9vw'} fontWeight={600} color={Colors.SecondaryText}>{'Additional Deformities'}</Typography>
                        {formState?.addDeformitiesEdit ?
                            <Button className='Common_Btn_Min_Width' onClick={() => {
                                setFormState((prevState) => ({
                                    ...prevState, addDeformitiesEdit: false
                                }))
                            }}>
                                <Box component={'img'} src={ImagePaths.UserEditOn.default} height={'1.5vw'} width={'1.5vw'} />
                            </Button>
                            :
                            <Box display={'flex'}>
                                <Button variant='contained'
                                    disabled={addDeformLoad || getCachevalue('DoctorUserChanged') === 'true'}
                                    sx={{ textTransform: 'capitalize', height: '2vw', width: '5vw', mr: '1vw' }}
                                    onClick={() => PostAddDeformitiesData()}
                                >Add</Button>
                                <Button variant='outlined'
                                    sx={{ textTransform: 'capitalize', height: '2vw', width: '5vw', mr: '1vw' }}
                                    onClick={() => ClearAddDeformitiesData()}
                                >Clear</Button>
                            </Box>
                        }
                    </Box>
                    {addDeformLoad ? <Box component={'div'} pl={'0.5vw'} pr={'0.5vw'} mb={'1vw'} height={'20vw'} display={'flex'} justifyContent={'center'} alignItems={'center'}><CircularProgress color='primary' /></Box> :
                        <Box component={'div'} pl={'0.5vw'} pr={'0.5vw'} mb={'1vw'}>
                            <Box component={'div'} display={'flex'} flexDirection={'row'} justifyContent={'space-between'} mt={'0.75vw'}>
                                <Box>
                                    {renderTextFieldRow('Dorsalis Pedis Artery', 'dorsalisPedisArtery', true, formState?.addDeformitiesEdit)}
                                    {renderTextFieldRow('Posterior Tibial Artery', 'posteriorTibialArtery', false, formState?.addDeformitiesEdit)}
                                    {renderTextFieldRow('Vibration Sensation', 'vibrationSensation', false, formState?.addDeformitiesEdit)}
                                    {renderTextFieldRow('Temperature Sensation', 'temperatureSensation', false, formState?.addDeformitiesEdit)}
                                    {renderTextFieldRow('Monofilament', 'monofilament', false, formState?.addDeformitiesEdit)}
                                    {renderTextFieldRow('Knee reflex', 'kneeReflex', false, formState?.addDeformitiesEdit)}
                                    {renderTextFieldRow('Ankle reflex', 'ankleReflex', false, formState?.addDeformitiesEdit)}
                                    {renderTextFieldRow('Others', 'addtionalOthers', false, formState?.addDeformitiesEdit)}
                                </Box>
                            </Box>
                        </Box>
                    }
                </Box>
            );
        } catch (error) {
            errorMessage(error.message)
        }
    };

    return (
        <Box component={"div"} sx={{ backgroundColor: Colors.ComponentBgColor, height: "74vh", padding: '0.5vw' }}>
            <Box component={'div'} display={'flex'} justifyContent={"space-between"} alignItems={"center"}>
                <Box component={'div'} className='doc_header_card' mr={'0.5vw'}>
                    <CommonPatientDetails data={formState?.patientDetails} showDetailed={true} />
                </Box>
                <Button className='Common_Btn_Min_Width' sx={{ marginRight: '0.65vw' }} onClick={() => printFootExaminationData()} >
                    <Box component={'img'} src={ImagePaths.PrintIcons.default} height={'2vw'} width={'2vw'} />
                </Button>
            </Box>
            <Box component={'div'} mt={'0.5vw'} height={'61.5vh'} overflow={'scroll'}>
                {renderFootClinicBox()}
                {renderGaitBox()}
                {renderDeformitiesBox()}
                {renderAddDeformitiesBox()}
            </Box>
            <Loader loaderOpen={isLoader} />
            {errorMsg && <ToastMsg severity={'error'} msg={errorMsgText} msgPop={msgClose} />}
            {successMsg && <ToastMsg severity={'success'} msg={successMsgText} msgPop={msgClose} />}
        </Box>
    );
};

export default DocFootExamination;